import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface ILinhaItensAhRemover{
  sequencial: number[];
  idLote: string[];
}

export const RecusarSolicitacaoSenhaMarcada = async(itens: ILinhaItensAhRemover) =>{
  const { token } = obterParametrosDaURL();

  try{
    await api.put(`/recusarsolicitacaosenhamarcada`,itens,{
      headers: { token }
    })
  }
  catch(e){
    throw new ApiException(
      e,
      "Não foi possível realizar a recusa dos itens!"
    );
  }
}